export default __webpack_public_path__ + "static/media/resetpassword.4298ec2b.svg";